export const DEFAULT_DATE_FORMAT = 'MM-DD-YYYY';



// WEBPACK FOOTER //
// ./src/app/constants/date-format.ts